export const NAVBAR_HEIGHT = 75;

export const navBarItems = {
  none: [],
  financier: [
    {
      label: 'Arrecadação',
      href: '/financier/arrecadacao/vencimento',
    },
    {
      label: 'Gestão Limite',
      href: '/financier/gestao-limite',
    },
    {
      label: 'Relatórios',
      href: '/financier/relatorios/painel-garantia',
    },
    {
      label: 'Documentação',
      href: '/financier/documentacao/gerenciamento',
    },
  ],
  app: [
    {
      label: 'Processamento',
      href: '/admin/processamento-propostas',
    },
    {
      label: 'Arrecadação',
      href: '/admin/arrecadacao',
    },
    {
      label: 'Antecipação',
      href: '/contratar',
    },
    {
      label: 'Garantia',
      href: '/garantia',
    },
    {
      label: 'Conta Digital',
      href: '/banking',
    },
    {
      label: 'Relatórios',
      href: '/relatorios',
    },
    {
      label: 'Gestão Limite',
      href: '/admin/gestao-limite',
    },
    {
      label: 'Documentação',
      href: '/documentacao',
    },
    {
      label: 'Participantes',
      href: '/admin/transportadoras',
    },
    /*
    {
      label: 'Painel de Controle',
      href: '/admin',
    },
    {
      label: 'Retirada Manual',
      href: '/retirada-manual',
    },
    */
  ],
  landing: [
    {
      label: 'Home',
      href: '#main',
    },
    {
      label: 'Como Funciona',
      href: '#como-funciona',
    },
    {
      label: 'Vantagens',
      href: '#vantagens',
    },
    {
      label: 'Sobre',
      href: '#sobre',
    },
  ],
};
